import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AQChip',
  props: {
    baseColor: {},
    color: {},
    text: {},
    closable: { type: Boolean },
    selected: { type: Boolean },
    variant: {},
    prependIcon: {},
    density: {},
    border: { type: [String, Number, Boolean] },
    size: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createBlock(_component_v_chip, _mergeProps(_ctx.$attrs, {
    baseColor: __props.baseColor,
    color: __props.color,
    text: __props.text,
    closable: __props.closable,
    selected: __props.selected,
    variant: __props.variant,
    prependIcon: __props.prependIcon,
    density: __props.density,
    border: __props.border,
    size: __props.size
  }), null, 16, ["baseColor", "color", "text", "closable", "selected", "variant", "prependIcon", "density", "border", "size"]))
}
}

})